import type { stats } from "@app/domain";

/**
 * An avatar fills this share of its frame: the frame's hole is 57-58 % of the picture and
 * hand-drawn, so the avatar's edge tucks under the ring (measured 13 Sept 2026, review 0014).
 */
export const FRAME_HOLE_SHARE = 0.6;

/** How far a frame reaches beyond its avatar's circle, on each side. */
export function frameReach(avatarSize: number): number {
  return (avatarSize / FRAME_HOLE_SHARE - avatarSize) / 2;
}

/** The frame picture for an avatar `avatarSize` wide, centred on it; the parent is positioned. */
export function RankFrameImage({
  rank,
  avatarSize,
}: {
  rank: stats.RankFrame;
  avatarSize: number;
}) {
  const size = avatarSize / FRAME_HOLE_SHARE;
  return (
    <img
      src={`/frames/${rank}.webp`}
      alt=""
      aria-hidden="true"
      draggable={false}
      className="pointer-events-none absolute left-1/2 top-1/2 max-w-none -translate-x-1/2 -translate-y-1/2 select-none"
      style={{ width: size, height: size }}
    />
  );
}
